import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  Box,
} from '@mui/material';

const CONTEXT_COPY = {
  withdrawal: {
    title: 'Verification required to withdraw',
    lead: 'Before we can send this withdrawal to your bank, Stripe needs to finish verifying your identity.',
    trailing: 'to authorize your ACH payment',
  },
  business_withdrawal: {
    title: "Finish your company's tax setup to withdraw",
    lead: "This withdrawal is on behalf of your company, so we need your company's EIN and business details on file before we send it — that way the earnings are reported to the company, not to you personally.",
    trailing: 'before we process this withdrawal on the company\'s behalf',
  },
  claim: {
    title: 'Verification required to claim your payout',
    lead: 'Before we can send this payout to your bank, Stripe needs to finish verifying your identity.',
    trailing: 'to authorize your ACH payment',
  },
  default: {
    title: 'Verification required',
    lead: 'Before we can send this ACH payment, Stripe needs to finish verifying your identity.',
    trailing: 'to authorize your ACH payment',
  },
};

function formatMissing(missingFields) {
  const fields = Array.isArray(missingFields) ? missingFields.filter(Boolean) : [];
  if (fields.length === 0) return 'the missing identity details';
  if (fields.length === 1) return `your ${fields[0]}`;
  if (fields.length === 2) return `your ${fields[0]} and ${fields[1]}`;
  return `your ${fields.slice(0, -1).join(', ')}, and ${fields[fields.length - 1]}`;
}

const StripeOnboardingRequiredModal = ({
  open,
  onClose,
  missingFields = [],
  onboardingUrl,
  context = 'default',
}) => {
  const copy = CONTEXT_COPY[context] || CONTEXT_COPY.default;
  const missingText = formatMissing(missingFields);

  const handleContinue = () => {
    if (onboardingUrl) {
      window.location.href = onboardingUrl;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{copy.title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {copy.lead} We still need {missingText} {copy.trailing}.
        </DialogContentText>
        <Alert severity="warning" sx={{ mb: 1 }}>
          Your payment can't be processed until verification is complete.
        </Alert>
        <Box sx={{ mt: 2 }}>
          <DialogContentText variant="body2">
            Click <b>Complete Verification</b> to finish securely on Stripe. You'll be brought
            right back here when you're done.
          </DialogContentText>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="text">
          Cancel
        </Button>
        <Button
          onClick={handleContinue}
          color="primary"
          variant="contained"
          disabled={!onboardingUrl}
        >
          Complete Verification
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StripeOnboardingRequiredModal;
